import "./banner/Banner.css";
import React, { useState } from "react";
import Banner from "./banner/Banner";
import All_Time_Fav from "./all_time_fav/All_Time_Fav";
import Product_vdo_preview from "./product_vdo_preview/Product_vdo_preview";
import Category_section from "./category-section/Category_section";
import { useDispatch, useSelector } from "react-redux";
import { AllShape, getAllCategories } from "../../features/master/masterSlice";
import { useEffect } from "react";
import {
  getAllProducts,
  getAllTimeFavsProducts,
} from "../../features/products/productsSlice";
import {
  getCustomerLove,
  getHomeBanner,
  getHomeShopAndWatch,
} from "../../features/home/homeSlice";
import { getAboutUs } from "../../features/aboutus/aboutusSlice";
import AOS from "aos";
import "aos/dist/aos.css";
import Reels from "./reels/Reels";
import Common_banner_holder from "../common-components/common_banner_holder/Common_banner_holder";
import Testimonials from "./testimonials/Testimonials";
import Why_Motherhood from "./why_Motherhood/Why_Motherhood";
import StorySection from "./story/Story";

function Home() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  AOS.init({ disable: "mobile" });

  const category = useSelector((state) => state.master.categories);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAllCategories());
  }, [dispatch]);

  const [shapeId, setShapeId] = useState();
  const productdata = useSelector((state) => state.product.allProductsFavs);
  useEffect(() => {
    dispatch(
      getAllTimeFavsProducts({
        shape_id: shapeId?.id,
      }),
    );
  }, [dispatch, shapeId]);

  const banner = useSelector((state) => state.home.banners);

  useEffect(() => {
    dispatch(getHomeBanner());
  }, [dispatch]);

  const about_us = useSelector((state) => state.aboutus.about_us);

  useEffect(() => {
    dispatch(getAboutUs());
  }, [dispatch]);

  const shapes = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(AllShape());
  }, [dispatch]);

  const watch_and_shop = useSelector(
    (state) => state.home.all_home_shop_and_watch,
  );

  useEffect(() => {
    dispatch(getHomeShopAndWatch());
  }, [dispatch]);

  const customer_love = useSelector((state) => state.home.all_customer_love);

  useEffect(() => {
    dispatch(getCustomerLove());
  }, [dispatch]);

  return (
    <>
      <Banner banner={banner} />
      <Category_section />
      <Product_vdo_preview about_us={about_us} />
      {/* <Common_banner_holder imgSrc="/assets/images/home/banner/banner_1.webp" /> */}

      <Why_Motherhood />
      <StorySection />

      {/* {watch_and_shop?.length > 0 && <Reels2 watch_and_shop={watch_and_shop} />} */}

      {/* {watch_and_shop?.length > 0 && <Reels watch_and_shop={watch_and_shop} />} */}

      {customer_love?.length > 0 && <Testimonials data={customer_love} />}
      <All_Time_Fav products={productdata} />
    </>
  );
}

export default Home;
